import Axios from 'axios';
import qs from 'qs';
export function G(url , data , success , fail){
    const domain = 'http://192.168.1.188/weinxinvipWebService/X5Service.asmx/'
    let Data = qs.stringify(data)
    Axios.get(url,data) .then(res => {
        success(res)
      })
      .catch(err => {
        fail(err)
      })
    }
  export default {
    G
  }


// WEBPACK FOOTER //
// ./src/page/wxget.js